import {
  NOTIFICATION_ACTIONS_KEYS,
  type NotificationActionPayloads,
} from "@config/local-notifications/notification-actions";
import {
  NOTIFICATION_ICONS,
  type NotificationIcon,
} from "@config/local-notifications/notification-icon";
import { Fields } from "remult";

export class NotificationBase {
  @Fields.id()
  id = "";

  @Fields.string()
  title = "";

  @Fields.string()
  content = "";

  @Fields.json<NotificationBase>({
    validate(entity) {
      const { actions } = entity;
      if (!actions) return true;
      if (!Array.isArray(actions)) return false;

      return actions.every((action) => {
        if (!action || typeof action !== "object") return false;
        if (!("id" in action) || !("extra" in action) || !("btnText" in action))
          return false;
        if (!NOTIFICATION_ACTIONS_KEYS.includes(action.id)) return false;
        return true;
      });
    },
  })
  actions: NotificationActionPayloads[] = [];

  // TODO: For migrations, ensure literal values are uppercased as per Remult's association/entity.ts reference.
  @Fields.literal(() => NOTIFICATION_ICONS, {
    defaultValue: () => "default",
  })
  icon?: NotificationIcon;

  @Fields.boolean({ dbName: "is_read" })
  hasRead = false;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
